import axios from 'axios';
// import config from '../config';
import { keys } from '../constants/keys';

export const fetchWeater = (zipcode) => axios.get(`http://api.openweathermap.org/data/2.5/weather?zip=${zipcode},mx&appid=${keys.getWeaterApiKey()}&units=metric`);
